import React from "react";

import PageWrapper from "../../Atoms/PageWrapper";
import FlexWrapper from "../../Atoms/FlexWrapper";
import MarginWrapper from "../../Atoms/MarginWrapper";

import "./Clients.css";
import Client1 from "../../Assets/Client1.png";
import Client2 from "../../Assets/Client2.png";
import Client3 from "../../Assets/Client3.png";
import Client4 from "../../Assets/Client4.png";
import Client5 from "../../Assets/Client5.png";
import Client6 from "../../Assets/Client6.png";
import Client7 from "../../Assets/Client7.png";
import Client8 from "../../Assets/Client8.png";
import Client9 from "../../Assets/Client9.png";
import Client10 from "../../Assets/Client10.png";
import Client11 from "../../Assets/Client11.png";
import Client12 from "../../Assets/Client12.png";

import Title from "../../Atoms/Title/Title";
import { isMobile } from "../../Utils/IsMobile";

const Clients = () => {
  const imageSource = [
    Client1,
    Client2,
    Client3,
    Client4,
    // Client5,
    Client6,
    Client7,
    Client8,
    Client9,
    Client10,
    Client11,
    Client12,
  ];

  return (
    <PageWrapper>
      <Title text={"Clients"} />
      <div className="wrapper">
        <div className="marquee">
          {imageSource.map((eachSource, index) => {
            return (
              <div className="clientImage" key={index} id={`${index}`}>
                <img
                  src={eachSource}
                  alt=""
                  width={"100%"}
                  height={"100%"}
                  style={{
                    maxWidth: isMobile ? "220px" : "150px",
                    width: isMobile ? "25vw" : "14vw",
                  }}
                />
              </div>
            );
          })}
          {imageSource.map((eachSource, index) => {
            return (
              <div className="clientImage" key={index}>
                <img
                  src={eachSource}
                  alt=""
                  width={"100%"}
                  height={"100%"}
                  style={{
                    maxWidth: isMobile ? "220px" : "150px",
                    width: isMobile ? "25vw" : "14vw",
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </PageWrapper>
  );
};

export default Clients;
